import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LotesService {

  constructor(private http: HttpClient) { }
  insertIncidenciasLote(data: any): Observable<any> {
  
    return this.http.post(environment.insertIncidenciasLote, data);
  }
}
